export function getBackgroundColor(useOnDark, disabled) {
  const baseBackgroundColor = useOnDark ? 'fill-surface-default' : 'fill-field-default';
  const disabledBackgroundColor = useOnDark ? 'fill-primary-disabled' : 'fill-field-disabled';
  return disabled ? disabledBackgroundColor : baseBackgroundColor;
}